/* eslint-disable default-case */
import Vue from 'vue';
import SUN_USUARIO from '@/graphql/revista/queries/Usuario.gql';
import SYSCOR_USUARIO from '@/graphql/revista/queries/UsuarioSyscor.gql';
import ESTADOS from '@/graphql/queries/Estados.gql';
import { isEqualTo, errorGQLHandler } from '@/helpers/helpers';
import * as types from '@/store/types/user.types';
import env from '@/config/env';
import { isArray } from 'util';
export const emitter = new Vue();
window.$emitter = emitter;

export default {
  namespaced: true,
  state: {
    system: 'syscor',
    ufSelect: null,
    uf_default: null,
    usSiglas: [],
    regionalTarget: [],
    emitUF: false,
    isAdmin: false,
    user: {
      id: null,
      nome: 'Conteúdos Vivo',
      funcao: null,
      filiais: [],
      uf: [],
      ufRegional: [],
      ufAcesso: [],
    },
  },
  getters: {
    uf: state => state.ufSelect,
    ufState: state => state.ufSelect,
    ufSiglas: state => state.usSiglas,
    user: state => state.user,
    filiais: state => state.user.filiais,
    regionalTarget: state => state.regionalTarget,
    userFunc: state => state.user.funcaoId,
    isAdmin: state => !!state.isAdmin,
  },
  mutations: {
    [types.USER_INFORMATION](state, payload) {
      state.usSiglas = payload.acesso;
      const existsUF = window.localStorage.getItem('revista.uf') || null;
      let uf;
      if (existsUF !== null) {
        const verify = (array, uf) => array.filter(f => f === uf)[0];
        uf = verify(payload.acesso, existsUF) ? existsUF : payload.acesso[0];
      } else {
        uf = payload.acesso.todas_uf ? 'RJ' : payload.acesso[0];
        window.localStorage.setItem('revista.uf', uf);
      }
      state.ufSelect = uf;
    },
    [types.USER_UF_SELECTED](state, payload) {
      state.ufSelect = payload;
      window.localStorage.setItem('revista.uf', payload);
    },
    [types.USER_SYSTEM](state, payload) {
      state.system = payload;
    },
    [types.USER_UF](state, payload) {
      state.usSiglas = payload;
      const existsUF = window.localStorage.getItem('revista.uf') || null;
      let uf;
      if (existsUF !== null) {
        const verify = (array, uf) => array.filter(f => f === uf)[0];
        uf = verify(payload, existsUF) ? existsUF : payload[0];
      } else {
        uf = payload.length === 27 ? 'RJ' : payload[0];
        window.localStorage.setItem('revista.uf', uf);
      }
      if (!state.emitUF) {
        window.$emitter.$emit('send.uf', uf);
        state.emitUF = true;
      }
      state.ufSelect = uf;
    },
    [types.SET_USER](state, payload) {
      state.user = payload;
    },
    [types.CLEAR_USER](state) {
      state.system = 'syscor';
      state.ufSelect = null;
      state.usSiglas = [];
      state.uf_default = null;
      state.regionalTarget = [];
      state.user = {
        id: null,
        nome: 'Conteúdos Vivo',
        funcao: null,
        filiais: [],
        uf: [],
        ufRegional: [],
        ufAcesso: [],
      };
    },
    [types.REGIONAL_ALVO](state, payload) {
      state.regionalTarget = payload;
    },
    [types.IS_ADMIN](state, payload) {
      state.isAdmin = payload;
    },
  },
  actions: {
    async userInfo({ commit, dispatch }) {
      const system = await window.localStorage.getItem('revista.modulo');
      // COMMIT SYSTEM
      await commit(types.USER_SYSTEM, system);
      try {
        const QUERY = isEqualTo(system, 'syscor') ? SYSCOR_USUARIO : SUN_USUARIO;
        const query = await env.apollo.query({
          query: QUERY,
        });

        let {
          id,
          nome,
          acesso,
          funcao: { nome: func, id: funId },
          admin,
          filiais,
          uf_default,
          regionaisAcesso,
        } = query.data.usuario;

        if (isEqualTo(system, 'syscor')) {
          filiais.map(filial => {
            if (filial.codigoDealer instanceof Object) {
              filial.codigoDealer = filial.codigoDealer.fa_cod_dealer;
            }

            return filial;
          });
        }

        filiais = filiais.filter(filial => {
          return filial.codigoDealer !== null && filial.codigoDealer !== undefined;
        });
        //const uf = isEqualTo(system, 'syscor') ? [window.localStorage.getItem('revista.uf')] : acesso.map(u => u.uf);
        // Remover a ternario acima e habilitar a constante abaixo quando
        // estiver pronto multi UF para SYSCOR
        if (uf_default) {
          window.localStorage.setItem('@revista:default', uf_default);
        }

        commit(types.IS_ADMIN, !!admin);

        window.$emitter.$emit('is-admin', !!admin);

        const uf = acesso.map(u => u.uf);

        await commit(types.USER_UF, uf);
        await dispatch('setUser', {
          id,
          nome,
          uf,
          funcao: func,
          funcaoId: funId,
          filiais,
          uf_default,
          regionaisAcesso,
          ufRegional: acesso,
        });
      } catch (e) {
        errorGQLHandler(e);
      }
    },
    setRegionalAlvo({ commit, state }, { id }) {
      let regionais = state.regionalTarget;

      if (!isArray(regionais)) {
        regionais = [];
      }

      regionais.push(id);

      commit(types.REGIONAL_ALVO, regionais);
    },
    resetRegionalAlvo({ commit }) {
      commit(types.REGIONAL_ALVO, []);
    },
    unsetRegionalAlvo({ commit, state }, { id }) {
      const regionais = state.regionalTarget;

      state.regionalTarget.forEach((regionalId, index) => {
        if (regionalId === id) {
          regionais.splice(index, 1);
        }
      });

      commit(types.REGIONAL_ALVO, regionais);
    },
    async setUser({ commit }, payload) {
      commit(types.SET_USER, payload);
    },
    async changeUF({ commit, dispatch }, uf) {
      await dispatch('apiRoute/setUF', { uf }, { root: true });
      await commit(types.USER_UF_SELECTED, uf, { cache: true });
      window.$emitter.$emit('send.uf', uf);
      // Habilitar quando a troca de UF para syscor estiver pronta
      if (isEqualTo(env.revista.modulo, 'syscor')) window.location.reload();
    },
    async clearUser({ commit }) {
      commit(types.CLEAR_USER);
      // Clear LocalStorage
      const re = /\W*(revista\W.*)\W*/g;
      Object.keys(window.localStorage).map(k => {
        if (!k.match(re)) {
          window.localStorage.removeItem(k);
        }
      });
    },
    async restoreUfsRegionais({ commit, state }) {
      const {
        user: { ufRegional },
      } = state;
      const ufsRegionaisRestored = [];

      for (let uf of ufRegional) {
        let {
          data: { estados },
        } = await env.apollo.query({
          query: ESTADOS,
          fetchPolicy: 'no-cache',
          variables: { id: uf.id },
        });
        ufsRegionaisRestored.push(estados.pop());
      }
      let userUpdated = { ...state.user };
      userUpdated.ufRegional = ufsRegionaisRestored;

      await commit(types.SET_USER, userUpdated);
    },
  },
};
